<div *ngIf="loader" class="loader">
    <mat-spinner></mat-spinner>
  </div>

<mat-card class="" *ngIf="!loader">
    <mat-card-header class="justify-content-between align-items-center mb-3 tryit">
      <mat-card-title class="fs-5 mb-0">
        Linked QR codes
      </mat-card-title>
        </mat-card-header>
    <div class="rounded-3 bg-light">
      <sm-data-table [columnHeaders]="tableDisplayColumns" [dataSource]="accountList"
         [showImageColumn]="true"  [imageTemplate]="image">
      </sm-data-table>
    </div>
  </mat-card>
  
  
  


  <ng-template #image let-objValue>
    <img
      [src]="
      objValue['documentThumbUrl'] && objValue['documentThumbUrl'] !== null && objValue['documentThumbUrl'] !== 'null'
          ? objValue['documentThumbUrl']
          : '../../../../assets/images/documents.png'
      "
      class="img-fluid rounded-circle"
    />
  </ng-template>
